import { Grid2D } from '../base/Grid2D';

export class WaterGrid extends Grid2D {
  private velocityX: Float32Array;
  private velocityY: Float32Array;

  constructor(width: number, height: number) {
    super(width, height, 0);
    const size = width * height;
    this.velocityX = new Float32Array(size);
    this.velocityY = new Float32Array(size);
  }

  /**
   * Get water height at (x, y). Alias for get() for backward compatibility.
   */
  public getHeight(x: number, y: number): number {
    return this.get(x, y);
  }

  /**
   * Set water height at (x, y). Alias for set() for backward compatibility.
   */
  public setHeight(x: number, y: number, height: number): void {
    this.set(x, y, height);
  }

  /**
   * Add to water height at (x, y). Alias for add() for backward compatibility.
   */
  public addHeight(x: number, y: number, delta: number): void {
    this.add(x, y, delta);
  }

  /**
   * Get velocity at (x, y).
   */
  public getVelocity(x: number, y: number): [number, number] {
    if (!this.isValid(x, y)) {
      return [0, 0];
    }
    const idx = this.getIndex(x, y);
    return [this.velocityX[idx], this.velocityY[idx]];
  }

  /**
   * Set velocity at (x, y).
   */
  public setVelocity(x: number, y: number, vx: number, vy: number): void {
    if (!this.isValid(x, y)) {
      return;
    }
    const idx = this.getIndex(x, y);
    this.velocityX[idx] = vx;
    this.velocityY[idx] = vy;
  }

  /**
   * Clear all water heights and velocities.
   */
  public clear(): void {
    super.clear();
    this.velocityX.fill(0);
    this.velocityY.fill(0);
  }
}
